import Axios from "axios";
import config from "../app.config";

export var chatSettingService;
export default chatSettingService = {
    checkChatSetting,
    storeChatSetting,
    removeChatSetting,
}

async function checkChatSetting() {
    return await Axios.get(`${config.LOCAL_API_URL}/chat-setting`, {})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function storeChatSetting(data) {
    return await Axios.post(`${config.LOCAL_API_URL}/chat-setting`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}

async function removeChatSetting() {
    return await Axios.delete(`${config.LOCAL_API_URL}/chat-setting`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error.response);
        })
}